import * as React from "react";
function SvgMagicWandCursor(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width={34}
      height={35}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(-1 1)"
      ref={svgRef}
      {...props}
    >
      <g filter="url(#magic-wand-cursor_svg__a)">
        <path
          d="M20.077 9.685l-1.143-2.04-.866-1.548 1.546.867 2.041 1.143 2.042-1.143 1.546-.867-.866 1.547-1.143 2.041 1.143 2.041.866 1.547-1.546-.866-2.041-1.143-2.042 1.143-1.328.744 9.4 9.4-.349.348.35-.348a1.41 1.41 0 010 1.996l-2.14 2.14a1.41 1.41 0 01-1.996 0l-9.4-9.4-.744 1.327-1.143 2.041 1.143 2.042.866 1.546-1.546-.866-2.042-1.143-2.04 1.143-1.547.866.866-1.546 1.143-2.041-1.143-2.042-.866-1.546 1.546.866 2.041 1.143 2.042-1.143 1.328-.744-1.163-1.163a1.41 1.41 0 010-1.996l.976-.985-1.141-.639-2.042-1.143-2.04 1.143-1.547.866.866-1.546 1.143-2.042-1.143-2.04-.866-1.548 1.546.867 2.041 1.143 2.042-1.143 1.546-.867-.866 1.547-1.143 2.041 1.143 2.041.639 1.14.974-.982.002-.002a1.41 1.41 0 011.996 0l1.172 1.173.744-1.329 1.143-2.04zm-5.284 5.34l1.524 1.523 1.23-1.231-1.523-1.524-1.23 1.231z"
          fill="currentColor"
          stroke="#fff"
        />
      </g>
      <defs>
        <filter
          id="magic-wand-cursor_svg__a"
          x={0.795}
          y={0.795}
          width={34.205}
          height={35.205}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48_233"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend
            in2="effect1_dropShadow_48_233"
            result="effect2_dropShadow_48_233"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
          <feBlend
            in2="effect2_dropShadow_48_233"
            result="effect3_dropShadow_48_233"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect3_dropShadow_48_233"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMagicWandCursor);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
